import React from "react";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ca from "date-fns/locale/ca";
import de from "date-fns/locale/de";
import enGB from "date-fns/locale/en-GB";
import es from "date-fns/locale/es";
import fi from "date-fns/locale/fi";
import fr from "date-fns/locale/fr";
import nl from "date-fns/locale/nl";
import PropTypes from "prop-types";

import { useI18n } from "libs/i18n";

const localeDateFnsLocaleAdapterMapping = {
  ca,
  en: enGB,
  es,
  de,
  fr,
  fi,
  nl,
};

/**
 * The component to use to wrap the whole application in order to provide the locales
 * to the components that comes from '@mui/x-date-pickers' lib.
 * TODO: optimization to not load all locales in the bundle.
 */
const DateLocalizationProvider = ({ children = null }) => {
  const i18n = useI18n();
  const [adapterLocale, setAdapterLocale] = React.useState(null);

  const { locale } = i18n;

  React.useEffect(
    () => {
      if (Object.keys(localeDateFnsLocaleAdapterMapping).includes(locale)) {
        setAdapterLocale(localeDateFnsLocaleAdapterMapping[locale]);
      } else {
        setAdapterLocale(enGB);
      }
    },
    [locale],
  );

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={adapterLocale}
      localeText={adapterLocale?.components?.MuiLocalizationProvider?.defaultProps?.localeText}
    >
      {children}
    </LocalizationProvider>
  );
};

DateLocalizationProvider.propTypes = {
  /**
   * The rest of the application to wrap to provide the good locale adapter to the components that need it.
   */
  children: PropTypes.node,
};

export default DateLocalizationProvider;
